var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationIconEvent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.00006H8.99992C9.54892 1.00006 9.99586 1.44676 9.99594 1.996V9.00409C9.99594 9.55308 9.67884 10 9.12984 10H0.99594C0.446863 10 0 9.553 0 9.00409V1.996C0 1.44676 0.446863 1.00006 0.99594 1.00006H2V0.483967C2 0.216701 2.21656 5.94854e-05 2.48383 5.94854e-05L2.51617 0C2.78336 0 3 0.216641 3 0.483908V1L7 1.00006V0.483967C7 0.216701 7.21656 5.94854e-05 7.48383 5.94854e-05H7.51601C7.78336 5.94854e-05 8 0.216701 8 0.483967V1.00006ZM0.99594 9.00003H9V3.50003H0.99594V9.00003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93219 6.75764L3.79141 7.62899C3.77223 7.74811 3.81913 7.86816 3.91271 7.93925C4.00643 8.01019 4.13089 8.01969 4.23329 7.96376L4.98502 7.55483L5.73675 7.96384C5.78122 7.98789 5.82996 8 5.87818 8C5.94133 8 6.00433 7.97939 6.05748 7.93933C6.15113 7.86823 6.19818 7.74819 6.17885 7.62906L6.03822 6.75772L6.64351 6.13896C6.72628 6.05446 6.75576 5.92836 6.72026 5.8136C6.6846 5.69892 6.58919 5.61496 6.47466 5.59734L5.63589 5.46772L5.25811 4.67643C5.20688 4.56841 5.10073 4.5 4.98494 4.5C4.86938 4.5 4.76331 4.56841 4.71163 4.67643L4.33422 5.46772L3.49546 5.59726C3.3807 5.61488 3.28573 5.69884 3.25 5.81352C3.21427 5.92828 3.24368 6.05453 3.3266 6.13888L3.93219 6.75764Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationIconEvent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notification-icon-event.9fab45fbf7413b158ea07650d87c489b.svg";